import '../home/home.scss'
import '../onboarding/onboarding.scss'
import './kyb.scss'
import { Box, Button, Paper, Tab, Typography } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NotificationsV2Datatable from './components/KybNotificationsV2/NotificationsV2Datatable'
import { updateKybNotificationsV2Filters } from '../../features/kybNotificationsV2/kybNotificationsV2Slice'
import SettingsIcon from '@mui/icons-material/Settings'
import { selectUserMaster } from '../../features/kyb/kybCountrySlice'
import KybNotificationsMonitoring from './components/KybNotificationsMonitoring/KybNotificationsMonitoring'

const KybNotificationsV2 = () => {
  const { tab } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation(['common', 'messages'])
  const actualTab = tab || 'BUSINESS'
  const { emailClient } = useSelector((state) => state.login)
  const userMaster = useSelector((state) => selectUserMaster(state, emailClient))

  const handleChange = (_, newValue) => {
    dispatch(
      updateKybNotificationsV2Filters({
        page: 0,
        limit: 25,
        offset: 0,
        fromDate: null,
        type: newValue,
      }),
    )
    navigate(`/kyb/notifications/${newValue}`)
  }

  return (
    <Box className="filter">
      <Box className="component-title" display="flex">
        <Typography variant="h2">{t('messages:kyb.menu.notifications')}</Typography>
      </Box>
      <Paper elevation={0}>
        <TabContext value={actualTab}>
          <Box
            className="component-title"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: '1.5rem' }}
          >
            {actualTab !== 'settings' && (
              <>
                <TabList onChange={handleChange} sx={{ marginBottom: 0 }}>
                  <Tab label={t('common:business')} value="BUSINESS" />
                  <Tab label={t('common:persons')} value="PERSON" />
                </TabList>
                {userMaster.kybMonitoringEnable && (
                  <Button
                    variant="outlined"
                    onClick={() => navigate('/kyb/notifications/settings')}
                    endIcon={<SettingsIcon />}
                  >
                    {t('common:settings')}
                  </Button>
                )}
              </>
            )}
          </Box>
          <TabPanel value="BUSINESS">
            <NotificationsV2Datatable type="BUSINESS" tableKey="notificationsV2Business" />
          </TabPanel>
          <TabPanel value="PERSON">
            <NotificationsV2Datatable type="PERSON" tableKey="notificationsV2Person" />
          </TabPanel>
          <TabPanel value="settings">
            <KybNotificationsMonitoring />
          </TabPanel>
        </TabContext>
      </Paper>
    </Box>
  )
}

export default KybNotificationsV2
